import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Dash } from "react-bootstrap-icons";

export default function ViewClassDetailsModal({ cancelModal, event }) {
  const [products, setProducts] = useState([]);
  const [currentAccess, setCurrentAccess] = useState([]);
  //styled
  const { user } = useAuthContext();

  const [isLoading, setIsLoading] = useState(false);

  const handleAddAccess = async (e) => {
    setIsLoading(true);
    const createProductAccess = {
      productId: e,
      eventId: event.id,
    };

    const accessResponse = await axios.post(
      `${ApiConnectionString}/api/productaccess`,
      createProductAccess,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (accessResponse.status == 200) {
      fetchData();
    }
  };

  const handleRemoveAccess = async (e) => {
    setIsLoading(true);
    const accessResponse = await axios.delete(
      `${ApiConnectionString}/api/productaccess/${e}/${event.id}`,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (accessResponse.status == 200) {
      fetchData();
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const prodResponse = await axios.get(
        `${ApiConnectionString}/api/ProductsRecurringByClub/${event.clubId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      const currentAccessResponse = await axios.get(
        `${ApiConnectionString}/api/ProductCurrentAccess/${event.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      setProducts(prodResponse.data);
      setCurrentAccess(currentAccessResponse.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error state if needed
    }
  };

  useEffect(() => {
    fetchData();
  }, [event.clubId, event.id, user.token]);

  // Remove products with IDs that match any ID in currentAccess
  const filteredProducts = products.filter((product) => {
    return (
      !currentAccess.some((access) => access.id === product.id) &&
      !product.totalAccess
    );
  });

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="send-modal-overlay">
            <div className="send-modal">
              <div className="blueBanner">
                <p className="fw-bold m-2 p-2 fontSize20">{event.name}</p>
              </div>

              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
              <table>
                <tbody>
                  <tr>
                    <td className="red-text fw-bold">Day:</td>
                    <td>{event.day}</td>
                  </tr>
                  <tr>
                    <td className="red-text fw-bold">Times:</td>
                    <td>
                      {`${String(event.timeIn)
                        .padStart(4, "0")
                        .slice(0, 2)}:${String(event.timeIn)
                        .padStart(4, "0")
                        .slice(2)} - ${String(event.timeOut)
                        .padStart(4, "0")
                        .slice(0, 2)}:${String(event.timeOut)
                        .padStart(4, "0")
                        .slice(2)}`}
                    </td>
                  </tr>
                  {event.bookingCapacity && (
                    <tr>
                      <td className="red-text fw-bold">Class Capacity:</td>
                      <td>{event.bookingCapacity}</td>
                    </tr>
                  )}

                  {event.price && (
                    <tr>
                      <td className="red-text fw-bold">
                        Price for one-off booking:
                      </td>
                      <td>£{(event.price / 100).toFixed(2)}</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="lightBlueBanner mt-4">
                <p className="fw-bold p-2">Access</p>
              </div>

              <p>
                Subscriptions with 'Total Access' are not listed here, as they
                automatically have access to all classes
              </p>
              {currentAccess.length == 0 && (
                <p>No subscriptions currently have access to this class</p>
              )}
              {currentAccess.map((product) => (
                <div key={product.id} className="d-flex">
                  {/* Render product details */}
                  <p className="mx-3">{product.name} </p>

                  <button
                    onClick={() => {
                      handleRemoveAccess(product.id);
                    }}
                    className="profile-blue-button mb-2 d-flex"
                  >
                    <Dash className="profile-social-icon" />
                    <a className="fw-bold mx-2 mt-1">Remove</a>
                  </button>
                </div>
              ))}

              <div className="send-modal-footer">
                <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
